import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useState } from "react";
import { useFileType, useImageConverter } from "../services/hooks/index.js";
import { FilePreviewWithZoom } from "../FilePreviewWithZoom/index.js";
import { useIsDesktop } from "../hooks/index.js";
import { Dialog } from "../Dialog/index.js";
import { useStyles } from "./FilePreviewWrapper.styles.js";
import { FilePreviewContent } from "./FilePreviewContent.js";
import { Error } from "./FilePreviewError.js";
import { Loader } from "./FilePreviewLoader.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function FilePreviewWrapper_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else FilePreviewWrapper_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const defaultSpasing = {};
const FilePreviewWrapper = (props)=>{
    const $ = c(61);
    const { onLoad, onError, clickable: t0, onClickOpen, onClickClose, onLoadSuccess, showSnackbarOnDesktop: t1, hideLoader: t2, withZoom: t3, defaultOpened: t4, fullScreen: t5, closeIcon: t6, withoutError: t7, mt: t8, mb: t9, alternativeImageComponent: t10 } = props;
    const clickable = void 0 === t0 ? false : t0;
    const showSnackbarOnDesktop = void 0 === t1 ? false : t1;
    const hideLoader = void 0 === t2 ? false : t2;
    const withZoom = void 0 === t3 ? false : t3;
    const defaultOpened = void 0 === t4 ? false : t4;
    const fullScreen = void 0 === t5 ? false : t5;
    const closeIcon = void 0 === t6 ? null : t6;
    const withoutError = void 0 === t7 ? false : t7;
    const mt = void 0 === t8 ? defaultSpasing : t8;
    const mb = void 0 === t9 ? defaultSpasing : t9;
    const alternativeImageComponent = void 0 === t10 ? false : t10;
    let t11;
    if ($[0] !== mb || $[1] !== mt) {
        t11 = {
            mt,
            mb
        };
        $[0] = mb;
        $[1] = mt;
        $[2] = t11;
    } else t11 = $[2];
    const { classes } = useStyles(t11);
    const isDesktop = useIsDesktop();
    const imageConverter = useImageConverter();
    const fileTypeService = useFileType();
    const [error, setError] = useState(false);
    const [blobType, setBlobType] = useState();
    const [objectUrl, setObjectUrl] = useState("");
    const [isDialogOpened, setIsDialogOpened] = useState(defaultOpened);
    let t12;
    if ($[3] !== onClickOpen) {
        t12 = ()=>{
            null == onClickOpen || onClickOpen();
            setIsDialogOpened(true);
        };
        $[3] = onClickOpen;
        $[4] = t12;
    } else t12 = $[4];
    const handleOpen = t12;
    let t13;
    if ($[5] !== onClickClose) {
        t13 = ()=>{
            setIsDialogOpened(false);
            null == onClickClose || onClickClose();
        };
        $[5] = onClickClose;
        $[6] = t13;
    } else t13 = $[6];
    const handleClose = t13;
    let t14;
    let t15;
    if ($[7] !== fileTypeService || $[8] !== imageConverter || $[9] !== onError || $[10] !== onLoad) {
        t14 = ()=>{
            let isCancelled = false;
            let nextObjectUrl = "";
            const loadFile = ()=>_async_to_generator(function*() {
                    try {
                        let file = yield onLoad();
                        const fileType = yield fileTypeService.fileTypeFromBlob(file);
                        if ([
                            "image/heic",
                            "image/heif",
                            "image/tiff",
                            "image/dng",
                            "image/x-adobe-dng"
                        ].includes(fileType)) file = yield imageConverter.convert(file);
                        if (!isCancelled) {
                            setBlobType(fileType);
                            nextObjectUrl = URL.createObjectURL(file);
                            setObjectUrl(nextObjectUrl);
                            setError(false);
                            if (onError) onError(void 0);
                        }
                    } catch (t16) {
                        const e = t16;
                        if (!isCancelled) {
                            setError(true);
                            if (onError) onError(e);
                        }
                    }
                })();
            loadFile();
            return ()=>{
                isCancelled = true;
                if (nextObjectUrl) URL.revokeObjectURL(nextObjectUrl);
            };
        };
        t15 = [
            imageConverter,
            onLoad,
            onError,
            fileTypeService
        ];
        $[7] = fileTypeService;
        $[8] = imageConverter;
        $[9] = onError;
        $[10] = onLoad;
        $[11] = t14;
        $[12] = t15;
    } else {
        t14 = $[11];
        t15 = $[12];
    }
    useEffect(t14, t15);
    if (error) {
        if (defaultOpened) {
            const t16 = !isDesktop;
            let t17;
            if ($[13] !== withoutError) {
                t17 = /*#__PURE__*/ jsx(Error, {
                    withoutError: withoutError
                });
                $[13] = withoutError;
                $[14] = t17;
            } else t17 = $[14];
            let t18;
            if ($[15] !== handleClose || $[16] !== t16 || $[17] !== t17) {
                t18 = /*#__PURE__*/ jsx(Dialog, {
                    onClose: handleClose,
                    open: true,
                    fullScreen: t16,
                    children: t17
                });
                $[15] = handleClose;
                $[16] = t16;
                $[17] = t17;
                $[18] = t18;
            } else t18 = $[18];
            return t18;
        }
        let t16;
        if ($[19] !== withoutError) {
            t16 = /*#__PURE__*/ jsx(Error, {
                withoutError: withoutError
            });
            $[19] = withoutError;
            $[20] = t16;
        } else t16 = $[20];
        return t16;
    }
    if (null === objectUrl || !blobType) {
        if (hideLoader) return null;
        if (defaultOpened) {
            const t16 = !isDesktop;
            let t17;
            if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
                t17 = /*#__PURE__*/ jsx(Loader, {});
                $[21] = t17;
            } else t17 = $[21];
            let t18;
            if ($[22] !== handleClose || $[23] !== t16) {
                t18 = /*#__PURE__*/ jsx(Dialog, {
                    onClose: handleClose,
                    open: true,
                    fullScreen: t16,
                    children: t17
                });
                $[22] = handleClose;
                $[23] = t16;
                $[24] = t18;
            } else t18 = $[24];
            return t18;
        }
        let t16;
        if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
            t16 = /*#__PURE__*/ jsx(Loader, {});
            $[25] = t16;
        } else t16 = $[25];
        return t16;
    }
    if (defaultOpened) {
        const hasZoom = withZoom && ("application/pdf" === blobType || (null == blobType ? void 0 : blobType.startsWith("image/")));
        if (hasZoom) {
            const t16 = "application/pdf" === blobType ? "pdf" : "image";
            let t17;
            if ($[26] !== alternativeImageComponent || $[27] !== handleClose || $[28] !== isDialogOpened || $[29] !== objectUrl || $[30] !== onLoadSuccess || $[31] !== showSnackbarOnDesktop || $[32] !== t16) {
                t17 = /*#__PURE__*/ jsx(FilePreviewWithZoom, {
                    onClose: handleClose,
                    open: isDialogOpened,
                    url: objectUrl,
                    onLoadSuccess: onLoadSuccess,
                    withBottomOffset: showSnackbarOnDesktop,
                    fileType: t16,
                    alternativeImageComponent: alternativeImageComponent
                });
                $[26] = alternativeImageComponent;
                $[27] = handleClose;
                $[28] = isDialogOpened;
                $[29] = objectUrl;
                $[30] = onLoadSuccess;
                $[31] = showSnackbarOnDesktop;
                $[32] = t16;
                $[33] = t17;
            } else t17 = $[33];
            return t17;
        }
        let t16;
        if ($[34] !== classes.paper) {
            t16 = {
                paper: classes.paper
            };
            $[34] = classes.paper;
            $[35] = t16;
        } else t16 = $[35];
        let t17;
        if ($[36] !== alternativeImageComponent || $[37] !== blobType || $[38] !== clickable || $[39] !== handleClose || $[40] !== handleOpen || $[41] !== isDialogOpened || $[42] !== objectUrl || $[43] !== props) {
            t17 = /*#__PURE__*/ jsx(FilePreviewContent, _object_spread_props(_object_spread({}, props), {
                blobType: blobType,
                objectUrl: objectUrl,
                handleOpen: handleOpen,
                handleClose: handleClose,
                clickable: clickable,
                open: isDialogOpened,
                alternativeImageComponent: alternativeImageComponent
            }));
            $[36] = alternativeImageComponent;
            $[37] = blobType;
            $[38] = clickable;
            $[39] = handleClose;
            $[40] = handleOpen;
            $[41] = isDialogOpened;
            $[42] = objectUrl;
            $[43] = props;
            $[44] = t17;
        } else t17 = $[44];
        let t18;
        if ($[45] !== closeIcon || $[46] !== fullScreen || $[47] !== handleClose || $[48] !== isDialogOpened || $[49] !== t16 || $[50] !== t17) {
            t18 = /*#__PURE__*/ jsxs(Dialog, {
                scroll: "body",
                onClose: handleClose,
                open: isDialogOpened,
                fullScreen: fullScreen,
                withoutRadius: fullScreen,
                className: "aqa_file_preview_dialog",
                classes: t16,
                children: [
                    t17,
                    closeIcon
                ]
            });
            $[45] = closeIcon;
            $[46] = fullScreen;
            $[47] = handleClose;
            $[48] = isDialogOpened;
            $[49] = t16;
            $[50] = t17;
            $[51] = t18;
        } else t18 = $[51];
        return t18;
    }
    let t16;
    if ($[52] !== alternativeImageComponent || $[53] !== blobType || $[54] !== clickable || $[55] !== handleClose || $[56] !== handleOpen || $[57] !== isDialogOpened || $[58] !== objectUrl || $[59] !== props) {
        t16 = /*#__PURE__*/ jsx(FilePreviewContent, _object_spread_props(_object_spread({}, props), {
            blobType: blobType,
            objectUrl: objectUrl,
            handleOpen: handleOpen,
            handleClose: handleClose,
            clickable: clickable,
            open: isDialogOpened,
            alternativeImageComponent: alternativeImageComponent
        }));
        $[52] = alternativeImageComponent;
        $[53] = blobType;
        $[54] = clickable;
        $[55] = handleClose;
        $[56] = handleOpen;
        $[57] = isDialogOpened;
        $[58] = objectUrl;
        $[59] = props;
        $[60] = t16;
    } else t16 = $[60];
    return t16;
};
export { FilePreviewWrapper };
